import type { Column } from '@/components/Organisms/DataTable/DataTable.types';
import { createdOnDateRanges } from '@/constants';
import { statusOptions } from '../constants';

export const columns: Column[] = [
	{
		key: 'clinic.name',
		label: 'Clinic',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'patient.fullname',
		label: 'Patient',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'products.ta_name',
		label: 'Product',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'ta_denial_date',
		label: 'Denial Date',
		width: '120px',
		type: 'date',
		dateISO: true,
		sorter: true,
		customDateRanges: createdOnDateRanges,
	},
	{
		key: 'ta_amountbilled',
		label: 'Invoice Amount',
		width: '130px',
		type: 'number',
		sorter: true,
	},
	{
		key: 'ta_appealstatus',
		label: 'Appeal Status',
		width: '150px',
		type: 'string-status',
		filterOptions: statusOptions,
	},
];
